import { Template } from './../../masterdata/models/template';
import { Printer } from '../../masterdata/models/printer';
export class APGPrintRequest {
    printer: Printer;
    template: Template
    numberOfCopies: number;
    cutsomPrefix: string;
    customFrom: string;
    customTo: string;
}